module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("To my mom, my grandma, and Andre—for your love, patience, and everything else that you’ve given to me over the years.")])])]), _c('a', {
    attrs: {
      "id": "dedication"
    }
  }), _c('p', {
    staticClass: "deda"
  }, [_c('a', {
    attrs: {
      "id": "dedication"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_vii"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("To my papaw—you will be missed.")])])]), _c('a', {
    attrs: {
      "id": "pag_vii"
    }
  }), _c('p', {
    staticClass: "deda"
  }, [_c('a', {
    attrs: {
      "id": "pag_vii"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("To all of the fans of Gin and the gang out there—this one’s for you.")])]), _c('a', {
    attrs: {
      "id": "pag_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pag_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0